import Navbar from "../sections/Navbar";

export default function Contact() {
    return (
        <>
                <Navbar navbarbtn1="navbar-btn"  navbarbtn2="navbar-btnactive"/>
        </>
    )
}